import { cn } from "@utils/tw"
import { ContentBlocks } from "eddev/blocks"
import { ComponentProps } from "react"

type Props = Omit<ComponentProps<typeof ContentBlocks>, "wrapBlock">

export function SubpageContentBlocks(props: Props) {
  return (
    <>
      <ContentBlocks
        blocks={props.blocks}
        wrapBlock={(children, ctx) => {
          const marginClass = ctx.current.flags?.marginRule && "block-margins-" + ctx.current.flags.marginRule
          if (ctx.current.blockName === "core/rich-text" || ctx.current.flags?.contentWidth) {
            return <div className={cn("col-subpage-content", marginClass)}>{children}</div>
          } else {
            return <div className={marginClass}>{children}</div>
          }
        }}
        {...props}
      />
    </>
  )
}
